import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Grid,
  TextField,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  InputLabel,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { CircularProgress } from "@mui/material";
import {
  ProformaInvoiceCreate,
  ApproveSolistapi,
  BankDetailList,
  ProformaInvoiceDetail,
  ProformaInvoiceUpdate,
  GetLastInvoiceByProject,
  GetNextPiNo,
} from "../../../Services/Services"; // adjust the path accordingly
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
const ProformaInvoiceForm = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showEditColumns, setShowEditColumns] = useState(false);
  const [includeLessAdvance, setIncludeLessAdvance] = useState(false);
  const [isDiscountEditable, setIsDiscountEditable] = useState(false);

  const getSelectedDivision = () => {
    try {
      const stored = localStorage.getItem("selectedDivision");
      return stored ? JSON.parse(stored) : null;
    } catch (e) {
      console.error("Failed to parse selectedDivision:", e);
      return null;
    }
  };

  const storedDivision = getSelectedDivision();

  const [formData, setFormData] = useState({
    created_by: localStorage.getItem("user_id"),
    gst_type: "", // added to help backend
    gst_percent: 0,
    gst_amount: 0, // 18% of 25000
    basic_value: 0, // 25000 + 4500
    advance_received: 0,
    net_payable: 0, // assume autogenerated
    installment_summary: "",
    amount_in_words: "",
    selected_project_id: "",
    pi_no: "",
    ra_bill_number: "",
    pi_date: new Date().toISOString().split("T")[0],
    project: "",
    shipping_address: "",
    address_selected: false,
    advance_percent: 0,
    retention_percentage: 0,
    retention_narration: "",
    advance_narration: "",
    retention_amount: 0,

    payment_terms: [
      { term: "50% advance along with the order" },
      { term: "50% against delivery" },
    ],
    tax_terms: [
      { term: "GST 18% Extra as Applicable" },
      { term: "Freight F.O.R. HFAL Site" },
    ],
    bank_details_id: "",

    total_amount: 0,
  });

  const initialFormData = {
    created_by: localStorage.getItem("user_id"),
    gst_type: "", // added to help backend
    gst_percent: 0,
    gst_amount: 0, // 18% of 25000
    basic_value: 0, // 25000 + 4500
    advance_received: 0,
    net_payable: 0, // assume autogenerated
    installment_summary: "",
    amount_in_words: "",
    selected_project_id: "",
    pi_no: "",
    pi_date: new Date().toISOString().split("T")[0],
    shipping_address: "",
    address_selected: false,
    advance_percent: 0,
    payment_terms: [
      { term: "50% advance along with the order" },
      { term: "50% against delivery" },
    ],
    tax_terms: [
      { term: "GST is not included" },
      { term: "Civil work is excluded" },
    ],
    bank_details_id: "",

    total_amount: 0, // add any other fields if needed
  };
  const [includeShipping, setIncludeShipping] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [gstType, setGstType] = useState("");
  const [gstPercent, setGstPercent] = useState(0);
  const [summary, setSummary] = useState("");
  const [advanceReceived, setAdvanceReceived] = useState(
    selectedProject ? selectedProject.rec_amount : 0,
  ); // default to 0 if no project selected
  const [selectedBankId, setSelectedBankId] = useState("");
  const [bankOptions, setBankOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [projectPage, setProjectPage] = useState(1);
  const [projectLoading, setProjectLoading] = useState(false);
  const [projectSearch, setProjectSearch] = useState("");
  const { invoice_number } = useParams();
  const [remainingAmount, setRemainingAmount] = useState(0);
  const [advanceBasic, setAdvanceBasic] = useState(0);
  const [advanceGstPercent, setAdvanceGstPercent] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");
  const [loading, setLoading] = useState(false); // 🔹 loader state
  const isEditMode = !!invoice_number;
  const location = useLocation();
  const amd = location.state?.amd;
  const passedInvoice = location.state?.invoice;
  // ✅ 1. Items initialization (Line ~245)
  useEffect(() => {
    const fetchInvoiceDetails = async () => {
      if (!isEditMode) return;

      try {
        setLoading(true);
        let data;

        if (passedInvoice) {
          data = passedInvoice;
        } else {
          data = await ProformaInvoiceDetail(invoice_number);
        }

        setFormData((prev) => ({
          ...prev,
          ...data,
          selected_project_id: data.project?.id,
          division: data.division,
          invoice_number: data.invoice_number,
          bank_details_id: data.bank_details?.id || data.bank_details,
          shipping_address: data.shipping_address || "",
          address_selected: data.address_selected || false,
          pi_date: data.pi_date || new Date().toISOString().split("T")[0],

          retention_narration: data.retention_narration || "",
          retention_percentage: parseFloat(data.retention_percentage) || 0,
          retention_amount: parseFloat(data.retention_amount) || 0,
          final_amount: parseFloat(data.final_amount) || 0,
        }));

        // ✅ CHANGE 1 & 2: Backend se rem_qty use karo
        let itemsToSet = [];

        if (data.pi_main_id && data.pi_main_id.length > 0) {
          itemsToSet = data.pi_main_id.map((piItem) => {
            const remQty = parseFloat(piItem.rem_qty) || 0;

            return {
              ...piItem,
              quantity: piItem.quantity || 0, // SO Qty
              // pi_qty: remQty === 0 ? 0 : (piItem.pi_qty || 0), // ✅ Change 1: rem_qty = 0 → pi_qty = 0
              pi_qty: piItem.pi_qty ?? 0,
              rem_qty: remQty, // ✅ Change 3: Backend value use karo, calculate mat karo
              dis_per: piItem.dis_per || 0,
              amount: piItem.total_amount || piItem.amount || 0,
              description: piItem.description || "",
              rate: piItem.rate || 0,
              uom: piItem.uom || piItem.unit?.symbol || "",
              item_name: piItem.item_name || piItem.item?.name || "",
            };
          });

          setShowEditColumns(true);
        } else if (data.project?.items && data.project.items.length > 0) {
          itemsToSet = data.project.items.map((item) => ({
            ...item,
            pi_qty: item.quantity,
            rem_qty: 0,
            uom: item.uom || item.unit?.symbol || "",
            item_name: item.item_name || item.item?.name || "",
          }));
        }
        setItems(itemsToSet);

        // ...
        setShippingAddress(data.shipping_address || "");
        setIncludeShipping(data.address_selected || false);
        setIncludeLessAdvance(
          data.includeLessAdvance !== undefined
            ? data.includeLessAdvance
            : true,
        );

        if (data.project) {
          setSelectedProject({
            id: data.project.id,
            project_name: data.project.project_name,
            client_name: data.project.party_details?.name,
            company_name: data.project.party_details?.company_name,
            shipping_address: data.project.party_details?.address,
            email: data.project.party_details?.email,
            shipping_contact: data.project.party_details?.contact,
            gst_no: data.project.party_details?.gst,
            pan_no: data.project.party_details?.pan,
            division_name: data.project.division_name,
            grand_total: data.project.grand_total,
            rec_amount: data.qty_advance_amt || 0,
            items: data.project.items || [],
            payment_terms: data.project.payment_terms || [],
          });
        }

        setSummary(data.installment_summary || "");
        setAdvanceGstPercent(data.advance_percent || "");
        setGstType(data.gst_type || "");
        setGstPercent(data.gst_percent || 0);
        setAdvanceReceived(data.project?.rec_amount || 0);
        setAdvanceBasic(data.advance_received || 0);
      } catch (err) {
        toast.error("Failed to load invoice details.");
      } finally {
        setLoading(false);
      }
    };

    fetchInvoiceDetails();
  }, [invoice_number, passedInvoice]);

  // ✅ Separate useEffect for bank details when bankOptions loads
  useEffect(() => {
    if (isEditMode && bankOptions.length > 0 && formData.bank_details_id) {
      const selectedBank = bankOptions.find(
        (b) => b.id === formData.bank_details_id,
      );
      if (selectedBank && !selectedBank.id === selectedBank?.id) {
        setSelectedBank(selectedBank);
      }
    }
  }, [bankOptions, formData.bank_details_id, isEditMode]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      shipping_address: shippingAddress,
      address_selected: includeShipping,
    }));
  }, [shippingAddress, includeShipping]);
  useEffect(() => {
    if (selectedProject) {
      setFormData((prev) => ({
        ...prev,
        selected_project_id: selectedProject.id,
      }));
    }
  }, [selectedProject]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      gst_type: gstType,
      gst_percent: gstPercent,
      installment_summary: summary,
    }));
  }, [gstType, gstPercent, summary]);

  useEffect(() => {
    const grandTotal = parseFloat(formData.total_amount || 0);
    const recAmount = parseFloat(selectedProject?.rec_amount || 0);
    const advance = parseFloat(advanceBasic) || 0;
    const gst = (grandTotal * gstPercent) / 100;
    const totalWithGst = grandTotal + gst;
    const netPayable =
      totalWithGst - (includeLessAdvance ? recAmount : 0) - advance;

    setFormData((prev) => ({
      ...prev,
      advance_received: advance,
      advance_percent: advanceGstPercent || 0,
      gst_amount: parseFloat(gst.toFixed(2)),
      basic_value: parseFloat(grandTotal.toFixed(2)),
      net_payable: parseFloat(netPayable.toFixed(2)),
      amount_in_words: numberToWords(parseFloat(netPayable.toFixed(2))),
    }));
  }, [
    advanceGstPercent,
    advanceBasic,
    gstPercent,
    formData.total_amount,
    includeLessAdvance,
    selectedProject?.rec_amount,
  ]);

  useEffect(() => {
    const fetchBankDetails = async () => {
      const data = await BankDetailList();

      const list = Array.isArray(data?.results) ? data.results : [];

      const transformed = list.map((item) => ({
        id: item.id,
        label: item.bank_name, // dropdown me ye dikhega
        account_number: item.account_number,
        bank_name: item.bank_name,
        ifsc_code: item.ifsc_code,
        branch_name: item.branch_name,
      }));

      setBankOptions(transformed);
    };
    fetchBankDetails();
  }, []);

  const numberToWords = (num) => {
    if (typeof num !== "number" || isNaN(num)) return "Invalid amount";
    if (num === 0) return "Zero Rupees only";

    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const numToWords = (n) => {
      if (n < 20) return a[n];
      if (n < 100)
        return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
      if (n < 1000)
        return (
          a[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 ? " " + numToWords(n % 100) : "")
        );
      return "";
    };

    const convert = (n) => {
      const crore = Math.floor(n / 10000000);
      n %= 10000000;
      const lakh = Math.floor(n / 100000);
      n %= 100000;
      const thousand = Math.floor(n / 1000);
      n %= 1000;
      const hundred = n;

      let result = "";

      if (crore) result += numToWords(crore) + " Crore ";
      if (lakh) result += numToWords(lakh) + " Lakh ";
      if (thousand) result += numToWords(thousand) + " Thousand ";
      if (hundred) result += numToWords(hundred);

      return result.trim() + " Rupees only";
    };

    return convert(Math.floor(num));
  };

  const keyLabelMap = {
    payment_terms: { fieldKey: "term", label: "Payment Term" },
    tax_terms: { fieldKey: "term", label: "Tax Term" },
  };

  const fetchProjects = async (page = 1, filters = {}) => {
    try {
      setProjectLoading(true);
      const divisionData = getSelectedDivision();
      const finalFilters = divisionData?.division_id
        ? { ...filters, division: divisionData.division_id }
        : filters;
      const response = await ApproveSolistapi(page, finalFilters);
      const results = Array.isArray(response.results)
        ? response.results
        : response || [];

      const mappedProjects = results.map((proj) => ({
        id: proj.id,
        project_name: proj.project_name,
        client_name: proj.party_details?.name,
        company_name: proj.party_details?.company_name,
        shipping_address: proj.party_details?.address,
        email: proj.party_details?.email,
        shipping_contact: proj.party_details?.contact,
        gst_no: proj.party_details?.gst,
        pan_no: proj.party_details?.pan,
        division_name: proj.division_name,
        grand_total: proj.grand_total,
        rec_amount: proj.rec_amount || 0,
        items: proj.items || [],
        terms_and_conditions: proj.terms_and_conditions || [],
      }));

      // Merge pages
      if (page === 1) {
        setProjectOptions(mappedProjects);
      } else {
        setProjectOptions((prev) => [...prev, ...mappedProjects]);
      }

      // Pagination control (Django REST style)
      setProjectPage(page);
    } catch (err) {
      toast.error("Failed to load project list");
    } finally {
      setProjectLoading(false);
    }
  };

  useEffect(() => {
    if (!isEditMode) {
      const delayDebounce = setTimeout(() => {
        fetchProjects(1, { project_name: projectSearch });
      }, 500);

      return () => clearTimeout(delayDebounce);
    }
  }, [projectSearch, isEditMode]);

  const [itemsList, setItems] = useState([]);
  const fetchNextPI = async () => {
    const data = await GetNextPiNo();
    if (data && data.pi_no) {
      setFormData((prev) => ({
        ...prev,
        pi_no: data.pi_no,
      }));
    }
  };

  useEffect(() => {
    if (!isEditMode) {
      fetchNextPI();
    }
  }, [isEditMode]);

  const handlePIQtyChange = (index, value) => {
    const updated = [...itemsList];
    const isBlank = value === "" || value === null;

    const rem_qty = parseFloat(updated[index].rem_qty) || 0;
    const rate = parseFloat(updated[index].rate) || 0;
    const dis_per = parseFloat(updated[index].dis_per) || 0;

    if (isBlank) {
      updated[index].pi_qty = "";
      let amount = 0;
      if (dis_per > 0) amount = amount * (1 - dis_per / 100);
      updated[index].amount = parseFloat(amount.toFixed(2));
      setItems(updated);
      recalculateTotals(updated);
      return;
    }

    const pi_qty = Number(value);
    if (!Number.isFinite(pi_qty) || pi_qty < 0) return;

    // if (rem_qty < pi_qty) {
    //   toast.error(`PI Qty cannot exceed Remaining Qty (${rem_qty})`);
    //   return;
    // }

    updated[index].pi_qty = pi_qty;

    let amount = pi_qty * rate;
    if (dis_per > 0) amount = amount * (1 - dis_per / 100);
    updated[index].amount = parseFloat(amount.toFixed(2));

    setItems(updated);
    recalculateTotals(updated);
  };

  const handleDiscountChange = (index, value) => {
    const updated = [...itemsList];
    updated[index].dis_per = parseFloat(value) || 0;

    setItems(updated);
    recalculateTotals(updated); // ✅ Let this handle calculation
  };

  const recalculateTotals = (items = itemsList) => {
    const totalAmount = items.reduce((acc, item) => {
      if (showEditColumns) {
        const qty = parseFloat(item.pi_qty) || 0;
        const rate = parseFloat(item.rate) || 0;
        const dis_per = parseFloat(item.dis_per) || 0;
        let amount = qty * rate;
        if (dis_per > 0) {
          amount = amount * (1 - dis_per / 100);
        }
        return acc + amount;
      } else {
        const qty = parseFloat(item.quantity) || 0;
        const rate = parseFloat(item.rate) || 0;
        const dis_per = parseFloat(item.dis_per) || 0;
        let amount = qty * rate;
        if (dis_per > 0) {
          amount = amount * (1 - dis_per / 100);
        }
        return acc + amount;
      }
    }, 0);

    const gstAmount = (totalAmount * gstPercent) / 100;
    const totalWithGst = totalAmount + gstAmount;
    const recAmount = parseFloat(selectedProject?.rec_amount || 0);
    const netPayable =
      totalWithGst - (includeLessAdvance ? recAmount : 0) - advanceBasic;

    setFormData((prev) => ({
      ...prev,
      total_amount: parseFloat(totalAmount.toFixed(2)),
      gst_amount: parseFloat(gstAmount.toFixed(2)),
      basic_value: parseFloat(totalAmount.toFixed(2)),
      net_payable: parseFloat(netPayable.toFixed(2)),
      amount_in_words: numberToWords(netPayable),
    }));
  };
  const handleToggleEditMode = () => {
    const newShowEditColumns = !showEditColumns;
    setShowEditColumns(newShowEditColumns);
    setIsDiscountEditable(newShowEditColumns);

    if (newShowEditColumns) {
      // ✅ Edit mode enable - Initialize PI Qty
      const updatedItems = itemsList.map((item) => ({
        ...item,
        pi_qty: isEditMode ? (item.pi_qty ?? item.quantity ?? 0) : "",
        rem_qty: item.rem_qty ?? 0,
      }));
      setItems(updatedItems);
    } else {
      // ✅ Edit mode disable - Reset to SO data
      const resetItems = itemsList.map((item) => ({
        ...item,
        amount: (item.quantity || 0) * (item.rate || 0),
      }));
      setItems(resetItems);

      // ✅ Reset GST and Advance states
      setGstType("");
      setGstPercent(0);
      setAdvanceGstPercent("");
      setAdvanceBasic("");
      setSummary("");

      toast.info("Edit mode disabled. GST and Advance reset to zero.");
    }
  };

  useEffect(() => {
    recalculateTotals();
  }, [
    showEditColumns,
    gstPercent,
    advanceBasic,
    includeLessAdvance,
    itemsList.length,
  ]);

  const handleProjectChange = async (newValue) => {
    if (!newValue) {
      setSelectedProject(null);
      setShippingAddress("");
      setFormData((prev) => ({
        ...prev,
        selected_project_id: null,
        items: [],
        shipping_address: "",
        address_selected: false,
      }));
      return;
    }

    setSelectedProject(newValue);
    if (!includeShipping) {
      const defaultAddress = newValue.shipping_address || "";
      setShippingAddress(defaultAddress);
      setFormData((prev) => ({
        ...prev,
        shipping_address: defaultAddress,
        address_selected: false, // Not manually selected
      }));
    }
    // setItems(newValue.items || []);
    setItems(
      (newValue.items || []).map((item) => ({
        ...item,
        uom: item.uom || item.unit?.symbol || "",
        item_name: item.item_name || item.item?.name || "",
        rem_qty: item.rem_qty ?? item.quantity ?? 0, // new form: use quantity
        pi_qty: "", // force BLANK for new PI
        dis_per: item.dis_per || 0,
        amount:
          item.amount ??
          (parseFloat(item.quantity) || 0) * (parseFloat(item.rate) || 0),
      })),
    );
    const mappedItems = newValue.items.map((item) => ({
      description: item.description || item.item?.name || "",
      quantity: item.quantity || 0,
      rate: item.rate || 0,
      unit: item.uom || "",
      amount: item.amount || item.quantity * item.rate || 0,
    }));

    const mappedPaymentTerms =
      newValue.terms_and_conditions
        ?.filter((t) => t.key.toLowerCase().includes("payment"))
        .map((t) => ({ term: t.value })) || [];

    const totalAmount = mappedItems.reduce(
      (acc, item) => acc + (item.amount || 0),
      0,
    );

    const advance = parseFloat(newValue.rec_amount || 0);
    const grandTotal = parseFloat(newValue.grand_total || 0);

    try {
      const lastInvoice = await GetLastInvoiceByProject(newValue.id);
      if (lastInvoice) {
        setGstType(lastInvoice.gst_type);
        setGstPercent(lastInvoice.gst_percent);
      }
    } catch (err) {}

    const gstAmount = (grandTotal * gstPercent) / 100;
    const totalWithGst = grandTotal + gstAmount;
    const netPayable = totalWithGst - advance;

    setFormData((prev) => ({
      ...prev,
      selected_project_id: newValue.id,
      items: mappedItems,
      total_amount: totalAmount,
      advance_received: advance,
      gst_amount: parseFloat(gstAmount.toFixed(2)),
      basic_value: parseFloat(totalWithGst.toFixed(2)),
      net_payable: parseFloat(netPayable.toFixed(2)),
      amount_in_words: numberToWords(netPayable),
      payment_terms: mappedPaymentTerms.length
        ? mappedPaymentTerms
        : prev.payment_terms,
    }));

    setAdvanceReceived(advance);
  };

  const handleBankChange = (e) => {
    const selectedId = parseInt(e.target.value);
    const selected =
      Array.isArray(bankOptions) &&
      bankOptions.find((b) => b.id === selectedId);
    setSelectedBank(selected); // UI ke liye

    if (selected) {
      setFormData((prev) => ({
        ...prev,
        bank_details_id: selected.id, // ✅ Sirf ID backend ke liye
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        bank_details_id: null,
      }));
    }
  };

  useEffect(() => {
    if (formData?.bank_details_id && bankOptions.length > 0) {
      const matchedBank = bankOptions.find(
        (b) => b.id === formData.bank_details_id,
      );
      if (matchedBank) {
        setSelectedBank(matchedBank);
      }
    }
  }, [formData.bank_details_id, bankOptions]);
  const handleItemChange = (e, index) => {
    const { name, value } = e.target;
    const updatedItems = [...formData.items];

    const parsedValue = ["quantity", "rate"].includes(name)
      ? parseFloat(value) || 0
      : value;

    updatedItems[index][name] = parsedValue;

    // ✅ Update amount instead of total
    const quantity = parseFloat(updatedItems[index].quantity) || 0;
    const rate = parseFloat(updatedItems[index].rate) || 0;
    updatedItems[index].amount = quantity * rate;

    // ✅ Recalculate total_amount from item.amount
    const totalAmount = updatedItems.reduce(
      (acc, item) => acc + (item.amount || 0),
      0,
    );

    // ✅ Calculate GST and net_payable
    const gstAmount = (totalAmount * formData.gst_percent) / 100;
    const totalWithGst = totalAmount + gstAmount;
    const netPayable = totalWithGst - formData.advance_received;
    setFormData({
      ...formData,
      items: updatedItems,
      total_amount: totalAmount,
      gst_amount: gstAmount,
      basic_value: totalWithGst,
      net_payable: netPayable,
      amount_in_words: numberToWords(netPayable),
    });
  };

  const handleDeleteWithConfirmation = (sectionKey, idx) => {
    const updated = [...formData[sectionKey]];
    updated.splice(idx, 1);
    setFormData({ ...formData, [sectionKey]: updated });
  };

  const navigate = useNavigate(); // Initialize router hook
  // 🔹 Save Draft
  const handleSaveDraft = () => {
    sessionStorage.setItem("proformaDraftForm", JSON.stringify(formData));
    sessionStorage.setItem(
      "proformaDraftProject",
      JSON.stringify(selectedProject),
    );
    sessionStorage.setItem("proformaDraftBank", JSON.stringify(selectedBank));

    toast.info("Draft saved successfully!");
  };

  // 🔹 Load Draft on Page Mount
  useEffect(() => {
    const draftForm = sessionStorage.getItem("proformaDraftForm");
    const draftProject = sessionStorage.getItem("proformaDraftProject");
    const draftBank = sessionStorage.getItem("proformaDraftBank");

    if (draftForm) {
      setFormData(JSON.parse(draftForm));
    }
    if (draftProject) {
      setSelectedProject(JSON.parse(draftProject));
    }
    if (draftBank) {
      setSelectedBank(JSON.parse(draftBank));
    }
  }, []);

  // 🔹 Clear Draft (Submit success ya Back button pe)
  const clearDraft = () => {
    sessionStorage.removeItem("proformaDraftForm");
    sessionStorage.removeItem("proformaDraftProject");
    sessionStorage.removeItem("proformaDraftBank");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const divisionData = getSelectedDivision();
    // if (!divisionData?.division_id) {
    //   toast.error(
    //     "No division selected. Please select a division from the header.",
    //   );
    //   setLoading(false);
    //   return;
    // }

    try {
      // Create a copy of formData to modify
      let submitData = { ...formData };

      // Always remove total_amount as it's not in the model
      delete submitData.total_amount;
      delete submitData.items;

      submitData.showEditColumns = showEditColumns;
      submitData.includeLessAdvance = includeLessAdvance;

      // ✅ Ensure these fields are included
      submitData.retention_narration = formData.retention_narration || "";
      submitData.retention_percentage = formData.retention_percentage || 0;
      submitData.retention_amount = formData.retention_amount || 0;
      submitData.qty_advance_amt = selectedProject.rec_amount || 0;
      // ✅ Calculate and add the final amount
      const totalWithGst =
        Number(formData.total_amount || 0) +
        (Number(formData.total_amount || 0) * gstPercent) / 100;
      const deduction =
        (totalWithGst * (formData.retention_percentage || 0)) / 100;
      submitData.final_amount = parseFloat(
        (totalWithGst - deduction).toFixed(2),
      );

      if (showEditColumns) {
        submitData.pi_items = itemsList.map((item) => {
          const piQty = Number(item.pi_qty) || 0; // blank → 0
          const rate = Number(item.rate) || 0;
          const disPer = Number(item.dis_per) || 0;

          let lineAmount = piQty * rate;
          if (disPer > 0) {
            lineAmount = lineAmount * (1 - disPer / 100);
          }

          return {
            item: item.item,
            item_name: item.item_name || "",
            description: item.description || "",
            quantity: Number(item.quantity) || 0,
            pi_qty: piQty,
            rem_qty: Number(item.rem_qty) || 0,
            dis_per: disPer,
            unit: item.unit || item.uom || "",
            rate: rate,
            total_amount: Number(lineAmount.toFixed(2)),
          };
        });
      } else {
        submitData.pi_items = null;
      }
      // ✅ Log to check data before sending
      console.log("Submitting data to backend:", {
        retention_narration: submitData.retention_narration,
        retention_percentage: submitData.retention_percentage,
        retention_amount: submitData.retention_amount,
        qty_advance_amt: selectedProject.rec_amount,
        // ... other fields
      });
      let response;
      if (isEditMode) {
        response = await ProformaInvoiceUpdate(invoice_number, submitData);
        if (response && Object.keys(response).length > 0) {
          toast.success("Proforma Invoice updated successfully!");
        }
      } else {
        response = await ProformaInvoiceCreate(submitData);
        if (response && Object.keys(response).length > 0) {
          toast.success("Proforma Invoice created successfully!");
        }
      }

      // Rest of your success handling...
      if (response && Object.keys(response).length > 0) {
        clearDraft();
        setFormData(initialFormData);
        setSelectedProject(null);
        setSelectedBank(null);
        setSelectedBankId(null);
        setGstType("");
        setSummary("");
        setGstPercent(0);
        setAdvanceReceived(0);
        setAdvanceGstPercent(0);
        setIncludeShipping(false);
        navigate("/dashboard/performatable");
      }
    } catch (err) {
      // Check for specific backend validation errors
      if (err.response && err.response.data) {
        const errorData = err.response.data;

        // Check for advance_percent validation error
        if (errorData.advance_percent) {
          const message = Array.isArray(errorData.advance_percent)
            ? errorData.advance_percent[0]
            : errorData.advance_percent;
          toast.error(message);
        }
        // Check for other field validation errors
        else if (typeof errorData === "object") {
          const errorMessages = [];
          Object.keys(errorData).forEach((field) => {
            if (Array.isArray(errorData[field])) {
              errorMessages.push(...errorData[field]);
            } else if (typeof errorData[field] === "string") {
              errorMessages.push(errorData[field]);
            }
          });

          if (errorMessages.length > 0) {
            toast.error(errorMessages.join(", "));
          } else {
            toast.error("Validation failed. Please check your input.");
          }
        }
        // Handle string error response
        else if (typeof errorData === "string") {
          toast.error(errorData);
        } else {
          toast.error("Server error. Please try again.");
        }
      }
      // Handle network errors
      else if (err.request) {
        toast.error("Network error. Please check your connection.");
      }
      // Handle other errors
      else {
        toast.error(err.message || "An unexpected error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xl">
      <ToastContainer position="top-right" autoClose={3000} />
      <form onSubmit={handleSubmit} autoComplete="off">
        <Box
          p={isMobile ? 1 : 2}
          sx={{ p: 0, pt: 0, mt: isMobile ? 3.5: -4, mb: 1 }}
        >
          <Grid container spacing={2}>
            {/* Buttons - Mobile Stack */}

            {/* PI No */}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="PI No."
                name="pi_no"
                value={formData.pi_no || ""}
                disabled
              />
            </Grid>

            {/* RA Bill No */}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="RA Bill No."
                name="ra_bill_number"
                value={formData.ra_bill_number || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    ra_bill_number: e.target.value,
                  }))
                }
              />
            </Grid>

            {/* PI Date */}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="PI Date"
                name="pi_date"
                type="date"
                value={formData.pi_date || ""}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, pi_date: e.target.value }))
                }
                InputLabelProps={{
                  shrink: true,
                }}
                required
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: 2,
                alignItems: isMobile ? "stretch" : "center",
                order: { xs: -1, md: 0 }, // 👈 यह line ADD करो
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                onClick={handleSaveDraft}
                fullWidth={isMobile}
                sx={{
                  borderRadius: 0,
                  color: "#ff8400ff",
                  borderColor: "#ff8400ff",
                  fontSize: "0.7rem",
                  height: 40,
                }}
              >
                Draft
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
                fullWidth={isMobile}
                sx={{ borderRadius: 0, height: 40, fontSize: "0.7rem" }}
              >
                {loading ? (
                  <CircularProgress size={22} color="inherit" />
                ) : isEditMode ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>
            </Grid>

            {/* Project */}
            <Grid item xs={12} md={3}>
              <Autocomplete
                fullWidth
                options={projectOptions}
                getOptionLabel={(option) => option.project_name || ""}
                value={selectedProject || null}
                loading={projectLoading}
                onOpen={() => {
                  if (projectOptions.length === 0) fetchProjects();
                }}
                onInputChange={(e, newInputValue) => {
                  setProjectSearch(newInputValue);
                }}
                onChange={(event, newValue) => handleProjectChange(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Project"
                    InputProps={{
                      ...params.InputProps,
                      style: {
                        height: "45px",
                      },
                      endAdornment: (
                        <>
                          {projectLoading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
              />
            </Grid>

            {selectedProject && (
              <>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Client Name"
                    value={selectedProject.client_name}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Company Name"
                    value={selectedProject.company_name}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Email"
                    value={selectedProject.email}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Contact"
                    value={selectedProject.shipping_contact}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="GST"
                    value={selectedProject.gst_no}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="PAN"
                    value={selectedProject.pan_no}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Division"
                    value={selectedProject.division_name}
                    fullWidth
                    disabled
                  />
                </Grid>
              </>
            )}
          </Grid>

          <Divider sx={{ my: 2 }} />

          <TableContainer component={Paper} sx={{ mb: 2 }}>
            <Table
              size="small"
              sx={{
                border: 1,
                borderColor: "grey.400",
                borderCollapse: "collapse",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      border: 1,
                      borderColor: "grey.400",
                      fontWeight: "bold",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    Description
                  </TableCell>

                  <TableCell
                    sx={{
                      border: 1,
                      borderColor: "grey.400",
                      fontWeight: "bold",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      Qty
                      <IconButton
                        size="small"
                        onClick={handleToggleEditMode}
                        sx={{ p: 0.5 }}
                      >
                        {showEditColumns ? (
                          <CloseIcon fontSize="small" sx={{ color: "red" }} />
                        ) : (
                          <EditIcon
                            fontSize="small"
                            sx={{ color: "#1976d2" }}
                          />
                        )}
                      </IconButton>
                    </Box>
                  </TableCell>

                  <TableCell
                    sx={{
                      border: 1,
                      borderColor: "grey.400",
                      fontWeight: "bold",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    UOM
                  </TableCell>

                  {showEditColumns && (
                    <TableCell
                      sx={{
                        border: 1,
                        borderColor: "grey.400",
                        fontWeight: "bold",
                        backgroundColor: "#f5f5f5",
                      }}
                    >
                      Rem Qty
                    </TableCell>
                  )}

                  {showEditColumns && (
                    <TableCell
                      sx={{
                        border: 1,
                        borderColor: "grey.400",
                        fontWeight: "bold",
                        backgroundColor: "#f5f5f5",
                        width: "100px",
                        padding: "4px 8px",
                      }}
                    >
                      PI Qty
                    </TableCell>
                  )}

                  <TableCell
                    sx={{
                      border: 1,
                      borderColor: "grey.400",
                      fontWeight: "bold",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    Rate
                  </TableCell>
                  <TableCell
                    sx={{
                      border: 1,
                      borderColor: "grey.400",
                      fontWeight: "bold",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    Disc (%)
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      border: 1,
                      borderColor: "grey.400",
                      fontWeight: "bold",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    Total
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {itemsList.map((item, index) => (
                  <TableRow key={index}>
                    {/* Description */}
                    <TableCell sx={{ border: 1, borderColor: "grey.400" }}>
                      <b>{item.item_name}</b>
                      <br />
                      {item.description}
                    </TableCell>

                    {/* SO Qty */}
                    <TableCell sx={{ border: 1, borderColor: "grey.400" }}>
                      {item.quantity}
                    </TableCell>

                    {/* UOM */}
                    <TableCell sx={{ border: 1, borderColor: "grey.400" }}>
                      {item.uom}
                    </TableCell>

                    {/* Rem Qty - Only in edit mode */}
                    {showEditColumns && (
                      <TableCell sx={{ border: 1, borderColor: "grey.400" }}>
                        {item.rem_qty}
                      </TableCell>
                    )}

                    {/* PI Qty Input - Only in edit mode */}
                    {showEditColumns && (
                      <TableCell sx={{ border: 1, borderColor: "grey.400" }}>
                        <TextField
                          type="number"
                          variant="standard"
                          value={item.pi_qty ?? ""}
                          onChange={(e) =>
                            handlePIQtyChange(index, e.target.value)
                          }
                        />
                      </TableCell>
                    )}

                    {/* ✅ NO EXTRA COLUMN HERE */}

                    {/* Rate */}
                    <TableCell sx={{ border: 1, borderColor: "grey.400" }}>
                      {item.rate}
                    </TableCell>

                    {/* Discount */}
                    <TableCell sx={{ border: 1, borderColor: "grey.400" }}>
                      {showEditColumns ? (
                        <TextField
                          type="number"
                          variant="standard"
                          value={item.dis_per || ""}
                          onChange={(e) =>
                            handleDiscountChange(index, e.target.value)
                          }
                          sx={{ width: "60px" }}
                        />
                      ) : (
                        item.dis_per || 0
                      )}
                    </TableCell>

                    {/* Total - Always calculated */}
                    <TableCell
                      align="right"
                      sx={{ border: 1, borderColor: "grey.400" }}
                    >
                      {(() => {
                        let qty;
                        if (showEditColumns) {
                          qty = parseFloat(item.pi_qty) || 0;
                        } else {
                          qty = parseFloat(item.quantity) || 0;
                        }

                        const rate = parseFloat(item.rate) || 0;
                        const dis_per = parseFloat(item.dis_per) || 0;

                        let amount = qty * rate;
                        if (dis_per > 0) {
                          amount = amount * (1 - dis_per / 100);
                        }

                        return amount.toFixed(2);
                      })()}
                    </TableCell>
                  </TableRow>
                ))}

                {/* All Summary Rows - Desktop */}
                <TableRow>
                  <TableCell
                    colSpan={showEditColumns ? 7 : 5}
                    align="right"
                    sx={{
                      border: 1,
                      borderColor: "grey.400",
                      fontWeight: "bold",
                    }}
                  >
                    Basic Value
                  </TableCell>
                  <TableCell sx={{ border: 1, borderColor: "grey.400" }}>
                    <TextField
                      value={(parseFloat(formData.total_amount) || 0).toFixed(
                        2,
                      )}
                      disabled
                      variant="standard"
                      fullWidth
                      InputProps={{
                        align: "right",
                        disableUnderline: true,
                        sx: { textAlign: "right", paddingRight: 1 },
                      }}
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    align="center"
                    colSpan={2}
                    sx={{
                      border: 1,
                      borderColor: "grey.400",
                    }}
                  >
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{ "& .MuiInputBase-root": { height: 38 } }}
                    >
                      <InputLabel>GST Type</InputLabel>
                      <Select
                        value={gstType || ""}
                        onChange={(e) => setGstType(e.target.value)}
                      >
                        <MenuItem value="None">None</MenuItem>
                        <MenuItem value="IGST">IGST</MenuItem>
                        <MenuItem value="CGST/SGST">CGST/SGST</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>

                  <TableCell
                    colSpan={showEditColumns ? 5 : 3}
                    sx={{
                      border: 1,
                      borderColor: "grey.400",
                    }}
                  >
                    <TextField
                      type="number"
                      placeholder="GST %"
                      value={gstPercent}
                      onChange={(e) => setGstPercent(Number(e.target.value))}
                      fullWidth
                      size="small"
                      sx={{ "& .MuiInputBase-input": { height: "15px" } }}
                    />
                  </TableCell>

                  <TableCell
                    colSpan={1}
                    align="right"
                    sx={{
                      border: 1,
                      borderColor: "grey.400",
                    }}
                  >
                    <TextField
                      placeholder="GST Amount"
                      value={(
                        ((formData.total_amount || 0.0) * gstPercent) /
                        100
                      ).toFixed(2)}
                      fullWidth
                      size="small"
                      disabled
                      sx={{ "& .MuiInputBase-input": { height: "15px" } }}
                    />
                  </TableCell>
                </TableRow>

                {gstPercent > 0 && (
                  <>
                    <TableRow>
                      <TableCell
                        colSpan={showEditColumns ? 7 : 5}
                        align="right"
                        sx={{
                          border: 1,
                          borderColor: "grey.400",
                          fontWeight: "bold",
                        }}
                      >
                        Total with GST
                      </TableCell>
                      <TableCell sx={{ border: 1, borderColor: "grey.400" }}>
                        {(
                          Number(formData.total_amount || 0.0) +
                          (Number(formData.total_amount || 0.0) * gstPercent) /
                            100
                        ).toFixed(2)}
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      {/* ✅ Ek Narration Field - Full Width */}
                      <TableCell
                        colSpan={showEditColumns ? 4 : 3}
                        sx={{
                          border: 1,
                          borderColor: "grey.400",
                        }}
                      >
                        <TextField
                          fullWidth
                          label="Less Advance Narration"
                          value={formData.advance_narration || ""}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              advance_narration: e.target.value,
                            }))
                          }
                          size="small"
                          sx={{ "& .MuiInputBase-root": { height: 38 } }}
                        />
                      </TableCell>

                      {/* Less Advance Checkbox */}
                      <TableCell
                        colSpan={showEditColumns ? 3 : 2}
                        align="right"
                        sx={{
                          border: 1,
                          borderColor: "grey.400",
                          fontWeight: "bold",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: 1,
                          }}
                        >
                          <Checkbox
                            checked={includeLessAdvance}
                            onChange={(e) =>
                              setIncludeLessAdvance(e.target.checked)
                            }
                            size="small"
                            sx={{ padding: 0 }}
                          />
                          <span>Less Advance</span>
                        </Box>
                      </TableCell>

                      {/* Advance Amount */}
                      <TableCell
                        colSpan={1}
                        align="right"
                        sx={{
                          border: 1,
                          borderColor: "grey.400",
                        }}
                      >
                        <TextField
                          type="number"
                          placeholder="Advance Amount"
                          value={selectedProject?.rec_amount ?? 0}
                          onChange={(e) => {
                            const value = e.target.value;
                            setSelectedProject((prev) => ({
                              ...prev,
                              rec_amount: value,
                            }));
                          }}
                          fullWidth
                          size="small"
                          sx={{
                            "& .MuiInputBase-input": {
                              height: "15px",
                            },
                          }}
                        />
                      </TableCell>
                    </TableRow>

                    {/* <TableRow>
                      <TableCell
                        colSpan={showEditColumns ? 7 : 5}
                        align="right"
                        sx={{
                          border: 1,
                          borderColor: "grey.400",
                          fontWeight: "bold",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: 1,
                          }}
                        >
                          <Checkbox
                            checked={includeLessAdvance}
                            onChange={(e) => setIncludeLessAdvance(e.target.checked)}
                            size="small"
                            sx={{ padding: 0 }}
                          />
                          <span>Less Advance</span>
                        </Box>
                      </TableCell>
                     
 <TableCell
                        colSpan={1}
                        align="right"
                        sx={{
                          border: 1,
                          borderColor: "grey.400",
                        }}
                      >
                        <TextField
                          type="number"
                          placeholder="Advance Amount"
                            value={selectedProject?.rec_amount ?? 0}  
                          onChange={(e) => {
                            const value = e.target.value;

                            setSelectedProject((prev) => ({
                              ...prev,
                              rec_amount: value,     
                            }));
                          }}
                          fullWidth
                          size="small"
                          sx={{
                            "& .MuiInputBase-input": {
                              height: "15px",
                            },
                          }}
                        />
                      </TableCell>
                    </TableRow> */}

                    <TableRow>
                      {/* Percentage Input */}
                      <TableCell
                        colSpan={3}
                        align="center"
                        sx={{
                          border: 1,
                          borderColor: "grey.400",
                        }}
                      >
                        <TextField
                          fullWidth
                          label="Retention Narration"
                          value={formData.retention_narration || ""}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              retention_narration: e.target.value,
                            }))
                          }
                          size="small"
                          multiline
                          rows={1}
                          sx={{ "& .MuiInputBase-root": { height: 38 } }}
                        />
                      </TableCell>
                      <TableCell
                        colSpan={showEditColumns ? 4 : 2}
                        sx={{
                          border: 1,
                          borderColor: "grey.400",
                        }}
                      >
                        <TextField
                          type="number"
                          placeholder="Percentage %"
                          value={formData.retention_percentage || ""}
                          onChange={(e) => {
                            const percentValue =
                              parseFloat(e.target.value) || 0;

                            // Use Basic Value instead of Total with GST
                            const basicValue = Number(
                              formData.total_amount || 0,
                            );

                            // Calculate deduction amount from Basic Value
                            const deductionAmount =
                              (basicValue * percentValue) / 100;

                            // Auto generate narration
                            const autoNarration =
                              percentValue > 0
                                ? `LESS: ${percentValue}% Balance Against Receipt of IBR Certiificate`
                                : "";

                            setFormData((prev) => ({
                              ...prev,
                              retention_percentage: percentValue,
                              retention_amount: parseFloat(
                                deductionAmount.toFixed(2),
                              ),
                              retention_narration: autoNarration,
                            }));
                          }}
                          fullWidth
                          size="small"
                          sx={{ "& .MuiInputBase-input": { height: "15px" } }}
                        />
                      </TableCell>

                      {/* Narration Field */}

                      {/* Deduction Amount Field */}
                      <TableCell
                        colSpan={1}
                        align="right"
                        sx={{
                          border: 1,
                          borderColor: "grey.400",
                        }}
                      >
                        <TextField
                          type="number"
                          placeholder="Deduction Amount"
                          value={formData.retention_amount || ""}
                          onChange={(e) => {
                            const deductionAmount =
                              parseFloat(e.target.value) || 0;

                            // Use Basic Value instead of Total with GST
                            const basicValue = Number(
                              formData.total_amount || 0,
                            );

                            // Calculate percentage based on Basic Value
                            const calculatedPercentage =
                              basicValue > 0
                                ? (deductionAmount / basicValue) * 100
                                : 0;

                            // Auto generate narration
                            const autoNarration =
                              calculatedPercentage > 0
                                ? `${calculatedPercentage.toFixed(2)}% of Basic Value `
                                : "";

                            setFormData((prev) => ({
                              ...prev,
                              retention_amount: deductionAmount,
                              retention_percentage: parseFloat(
                                calculatedPercentage.toFixed(2),
                              ),
                              retention_narration: autoNarration,
                            }));
                          }}
                          fullWidth
                          size="small"
                          sx={{
                            "& .MuiInputBase-input": {
                              height: "15px",
                            },
                          }}
                        />
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell
                        colSpan={showEditColumns ? 7 : 5}
                        align="right"
                        sx={{
                          border: 1,
                          borderColor: "grey.400",
                          fontWeight: "bold",
                        }}
                      >
                        Net Payable
                      </TableCell>
                      <TableCell sx={{ border: 1, borderColor: "grey.400" }}>
                        {(
                          Number(formData.total_amount || 0) +
                          (Number(formData.total_amount || 0) * gstPercent) /
                            100 -
                          (includeLessAdvance
                            ? Number(selectedProject?.rec_amount || 0)
                            : 0) -
                          Number(formData.retention_amount || 0)
                        ).toFixed(2)}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                <TableRow>
                  <TableCell
                    colSpan={2}
                    align="right"
                    sx={{
                      border: 1,
                      borderColor: "grey.400",
                      fontWeight: "bold",
                    }}
                  >
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        minWidth: 100,
                        "& .MuiInputBase-root": { height: 38 },
                      }}
                    >
                      <TextField
                        label="Advance%"
                        type="number"
                        value={advanceGstPercent || ""}
                        onChange={(e) => {
                          const val =
                            e.target.value === "" ? "" : Number(e.target.value);
                          setAdvanceGstPercent(val);
                          if (val !== "") {
                            setSummary(
                              `PAYABLE AS ADV @${val}% OF ${gstPercent > 0 ? "TOTAL" : "BASIC"} VALUE`,
                            );

                            // Calculate Net Payable (same formula as shown in Net Payable row)
                            const totalWithGst =
                              Number(formData.total_amount || 0) +
                              (Number(formData.total_amount || 0) *
                                gstPercent) /
                                100;

                            const netPayable =
                              totalWithGst -
                              (includeLessAdvance
                                ? Number(selectedProject?.rec_amount || 0)
                                : 0) -
                              Number(formData.retention_amount || 0);

                            // Calculate advance based on Net Payable
                            setAdvanceBasic(
                              ((netPayable * val) / 100).toFixed(2),
                            );
                          }
                        }}
                        inputProps={{ min: 0 }}
                        fullWidth
                      />
                    </FormControl>
                  </TableCell>
                  <TableCell
                    colSpan={showEditColumns ? 5 : 3}
                    align="right"
                    sx={{
                      border: 1,
                      borderColor: "grey.400",
                      fontWeight: "bold",
                    }}
                  >
                    <TextField
                      type="text"
                      size="small"
                      value={summary}
                      onChange={(e) => setSummary(e.target.value)}
                      fullWidth
                      required
                      sx={{ "& .MuiInputBase-input": { height: "15px" } }}
                    />
                  </TableCell>

                  <TableCell sx={{ border: 1, borderColor: "grey.400" }}>
                    <TextField
                      colSpan={showEditColumns ? 7 : 5}
                      type="number"
                      size="small"
                      value={advanceBasic}
                      onChange={(e) => setAdvanceBasic(Number(e.target.value))}
                      fullWidth
                      required
                      sx={{ "& .MuiInputBase-input": { height: "15px" } }}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Divider sx={{ my: 2 }} />

          {/* Bank Details */}
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <TextField
                select
                fullWidth
                value={selectedBank ? selectedBank.id : ""}
                onChange={handleBankChange}
                SelectProps={{ native: true }}
                required
              >
                <option value="" disabled>
                  Select bank
                </option>
                {Array.isArray(bankOptions) &&
                  bankOptions.map((bank) => (
                    <option key={bank.id} value={bank.id}>
                      {bank.id} - {bank.bank_name}-{bank.account_number}
                    </option>
                  ))}
              </TextField>
            </Grid>

            {selectedBank && (
              <>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Account No"
                    value={selectedBank.account_number}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Bank Name"
                    value={selectedBank.bank_name}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="IFSC Code"
                    value={selectedBank.ifsc_code}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Branch Name"
                    value={selectedBank.branch_name}
                    fullWidth
                    disabled
                  />
                </Grid>
              </>
            )}
          </Grid>

          {/* Shipping */}
          {/* <Box sx={{ mt: 4, mb: 3 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeShipping}
                  onChange={(e) => setIncludeShipping(e.target.checked)}
                />
              }
              label="New billing address"
            />
            {includeShipping && (
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Shipping Address"
                    value={shippingAddress}
                    onChange={(e) => {
                      const newAddress = e.target.value;
                      setShippingAddress(newAddress);
                      setFormData((prev) => ({
                        ...prev,
                        shipping_address: newAddress,
                        address_selected: true,
                      }));
                    }}
                  />
                </Grid>
              </Grid>
            )}
          </Box> */}

          <Divider sx={{ my: 2 }} />

          {/* Terms Section */}
          <Grid container spacing={2}>
            {Object.entries(keyLabelMap).map(
              ([sectionKey, { fieldKey, label }]) => (
                <Grid item xs={12} md={6} key={sectionKey}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                      border: "1px solid #ddd",
                      borderRadius: 2,
                    
                      p: 2,
                    }}
                  >
                    <strong>{label}s</strong>
                    {formData[sectionKey].map((item, idx) => (
                      <Box
                        key={idx}
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <TextField
                          fullWidth
                          label={`${label} ${idx + 1}`}
                          value={item[fieldKey]}
                          error={!(item[fieldKey] || "").trim()}
                          helperText={
                            !(item[fieldKey] || "").trim()
                              ? `${label} cannot be empty`
                              : ""
                          }
                          onChange={(e) => {
                            const updated = [...formData[sectionKey]];
                            updated[idx][fieldKey] = e.target.value;
                            setFormData({ ...formData, [sectionKey]: updated });
                          }}
                        />
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() =>
                            handleDeleteWithConfirmation(sectionKey, idx)
                          }
                          // disabled={formData[sectionKey].length === 1}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                        {idx === formData[sectionKey].length - 1 && (
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => {
                              const updated = [...formData[sectionKey]];
                              updated.push({ [fieldKey]: "" });
                              setFormData({
                                ...formData,
                                [sectionKey]: updated,
                              });
                            }}
                          >
                            <AddIcon fontSize="small" />
                          </IconButton>
                        )}
                      </Box>
                    ))}
                  </Box>
                </Grid>
              ),
            )}
          </Grid>
        </Box>
      </form>
    </Container>
  );
};

export default ProformaInvoiceForm;
